var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 3.62832L21 3.12832L22 1.12832L19.536 1.82832C18.2285 0.608531 16.3209 0.28307 14.6829 1.00034C13.0449 1.7176 11.9903 3.34021 12 5.12832V6.12832C8.461 6.85832 5.366 4.92832 2.5 1.62832C2 4.29499 2.5 6.29499 4 7.62832L1 7.12832C1.405 9.19732 2.362 10.8283 5 11.1283L2.5 12.1283C3.5 14.1283 5.066 14.4383 7.5 14.6283C5.60692 15.981 3.32603 16.6828 1 16.6283C13.755 22.2973 21 13.9643 21 6.62832V5.30032L23 3.62832Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9bba2d73ac5222bdfbca81aeab9d0ec7.svg";
export { ForwardRef as ReactComponent };